import {
  makeUserLoginFailedErrorMessageSelector,
  makeUserLoginFailedSelector,
  makeUserLoginRequestedSelector,
  makeUserLoginSucceededSelector,
  makeUserSelector,
} from '../store/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import { createStructuredSelector } from 'reselect';
import { userLoginAction } from '../store/actions';

function useLogin() {
  const dispatch = useDispatch();
  const {
    userLoginRequested,
    userLoginSucceeded,
    userLoginFailed,
    userLoginFailedErrorMessage,
    user,
  } = useSelector(
    createStructuredSelector({
      userLoginRequested: makeUserLoginRequestedSelector(),
      userLoginSucceeded: makeUserLoginSucceededSelector(),
      userLoginFailed: makeUserLoginFailedSelector(),
      user: makeUserSelector(),
      userLoginFailedErrorMessage: makeUserLoginFailedErrorMessageSelector(),
    })
  );

  function loginSubmit(username, password) {
    dispatch(userLoginAction(username, password));
  }

  return {
    loginUser: user,
    loginSubmit,
    loginSubmitRequested: userLoginRequested,
    loginSubmitSucceeded: userLoginSucceeded,
    loginSubmitFailed: userLoginFailed,
    loginSubmitFailedErrorMessage: userLoginFailedErrorMessage,
  };
}

export default useLogin;
